import styled from 'styled-components'
import { breakPointsCss, measurments } from '../utils/config'

const StyledLogo = styled.div`
  img,
  svg {
    max-height: calc(${measurments.navHeight}px - 2rem);
    width: 100%;
    object-fit: contain;
    object-position: left;
  }
  h1 {
    display: none;
  }
  .logo-mobile {
    display: none;
  }
  ${breakPointsCss.tablet} {
    .logo-mobile {
      display: block;
      max-height: calc(${measurments.navHeight}px - 0.5rem);
    }
    .logo-desktop {
      display: none;
    }
  }
`

type Props = {
  href?: string
}

const Logo = ({ href }: Props) => {
  return (
    <a href={href || 'https://atlascloud.se'} className='clean'>
      <StyledLogo>
        <>
          <img
            src='/images/logo_full_blue.png'
            alt='Atlas Cloud'
            className='logo-desktop'
          />
          <img
            src='/images/logo_symbol_blue.png'
            alt='Atlas Cloud'
            className='logo-mobile'
          />
        </>

        <h1>Atlas Cloud</h1>
      </StyledLogo>
    </a>
  )
}

export default Logo
